/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Standard_2day_InstantreadyInputs */

const en_standard_2day_instantready = /** @type {(inputs: Standard_2day_InstantreadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard 2-Day (Instant-Ready)`)
};

const es_standard_2day_instantready = /** @type {(inputs: Standard_2day_InstantreadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estándar 2 días (Listo para instantáneo)`)
};

const fr_standard_2day_instantready = /** @type {(inputs: Standard_2day_InstantreadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard 2 Jours (Prêt pour l'instantané)`)
};

const de_standard_2day_instantready = /** @type {(inputs: Standard_2day_InstantreadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard 2-Tage (Instant-Ready)`)
};

const ja_standard_2day_instantready = /** @type {(inputs: Standard_2day_InstantreadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スタンダード2日間 (即時支払い対応)`)
};

const zh_standard_2day_instantready = /** @type {(inputs: Standard_2day_InstantreadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标准 2 天 (支持即时提现)`)
};

const ar_standard_2day_instantready = /** @type {(inputs: Standard_2day_InstantreadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أساسي يومين (جاهز للفوري)`)
};

const id_standard_2day_instantready = /** @type {(inputs: Standard_2day_InstantreadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standar 2 Hari (Siap-Instan)`)
};

const it_standard_2day_instantready = /** @type {(inputs: Standard_2day_InstantreadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard 2 Giorni (Pronto Istantaneo)`)
};

const ru_standard_2day_instantready = /** @type {(inputs: Standard_2day_InstantreadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стандартная 2 дня (готово к мгновенным выплатам)`)
};

const pt_standard_2day_instantready = /** @type {(inputs: Standard_2day_InstantreadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Padrão 2 Dias (Pronto para Imediato)`)
};

const ko_standard_2day_instantready = /** @type {(inputs: Standard_2day_InstantreadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`표준 2일 (즉시 정산 가능)`)
};

/**
* | output |
* | --- |
* | "Standard 2-Day (Instant-Ready)" |
*
* @param {Standard_2day_InstantreadyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const standard_2day_instantready = /** @type {((inputs?: Standard_2day_InstantreadyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Standard_2day_InstantreadyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_standard_2day_instantready(inputs)
	if (locale === "es") return es_standard_2day_instantready(inputs)
	if (locale === "fr") return fr_standard_2day_instantready(inputs)
	if (locale === "de") return de_standard_2day_instantready(inputs)
	if (locale === "ja") return ja_standard_2day_instantready(inputs)
	if (locale === "zh") return zh_standard_2day_instantready(inputs)
	if (locale === "ar") return ar_standard_2day_instantready(inputs)
	if (locale === "id") return id_standard_2day_instantready(inputs)
	if (locale === "it") return it_standard_2day_instantready(inputs)
	if (locale === "ru") return ru_standard_2day_instantready(inputs)
	if (locale === "pt") return pt_standard_2day_instantready(inputs)
	return ko_standard_2day_instantready(inputs)
});